
import React from 'react';
const SvgEllipsesMenu = ({ title, ...props }) => (
    <svg viewBox="100 100 190 190" {...props}>
        {title ? <title>{title}</title> : null}
        <circle cx={195} cy={144.9} r={16.7} />
        <circle cx={195} cy={195} r={16.7} />
        <circle cx={195} cy={245.1} r={16.7} />
    </svg>
);
export default SvgEllipsesMenu;